import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-6 mt-auto">
      <div className="container mx-auto px-4 text-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="text-sm text-gray-600">
            <p>&copy; 2024 Standard Repayment Calculations. Professional loan calculation tools.</p>
          </div>
          
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-500">Made on</span>
            <a 
              href="https://www.zapt.ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 font-medium text-sm transition-colors"
            >
              ZAPT
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;